module.exports = __webpack_public_path__ + "static/media/logo_4.c1579af6.svg";